module.exports = __webpack_public_path__ + "static/media/foundation.fbebcf08.png";